export default {
    type: 'hero-carousel-2',
    name: 'Hero Carousel',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleHeroCarousel',
            loader: () => import('./ModuleHeroCarousel')
        },
        form: {
            name: 'ModuleHeroCarouselForm',
            loader: () => import('./ModuleHeroCarouselForm')
        }
    }
};
